import React, { Fragment } from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import { BANNER_TEMPLATE } from '../../common/constant';
import Image from '../../common/image';
import { PUBLIC_BUCKET_CDN } from '../../network/api';


const HHImageTemplates = ({
  field,
  form: { setFieldValue }
}) => {
  const handleImageTemplateOnClick = async (e, objectKey) => {
    e.preventDefault();
    if (field.name === 'bannerBg') {
      setFieldValue('bannerBgTempUrl', `${PUBLIC_BUCKET_CDN}${objectKey}`);
    } else if (field.name === 'coverImageUrl') {
      setFieldValue('coverImageTempUrl', `${PUBLIC_BUCKET_CDN}${objectKey}`);
    }
    setFieldValue(field.name, objectKey);
  };

  let template = '';

  const isCurrentSelected = (key) => {
    if (key === field.value) {
      return 'selectedImageTemplate';
    }
    return 'imageTemplate';
  };

  if (field.name === 'bannerBg') {
    template = (
      <Grid columns='equal' className='bannerImageTemplates'>
        <Grid.Row>
          <Grid.Column className='left'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerOne}`}
                alt='banner template 1'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerOne)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerOne)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='right'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerTwo}`}
                alt='banner template 2'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerTwo)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerTwo)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className='left'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerThree}`}
                alt='banner template 3'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerThree)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerThree)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='right'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerFour}`}
                alt='banner template 4'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerFour)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerFour)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className='left'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerFive}`}
                alt='banner template 5'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerFive)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerFive)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='right'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.bannerSix}`}
                alt='banner template 6'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.bannerSix)}
                className={isCurrentSelected(BANNER_TEMPLATE.bannerSix)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  } else {
    template = (
      <Grid columns='equal'>
        <Grid.Row>
          <Grid.Column className='left'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverOne}`}
                alt='cover template 1'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverOne)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverOne)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='middle'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverTwo}`}
                alt='cover template 2'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverTwo)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverTwo)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='right'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverThree}`}
                alt='cover template 3'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverThree)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverThree)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column className='left'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverFour}`}
                alt='cover template 4'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverFour)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverFour)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='middle'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverFive}`}
                alt='cover template 5'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverFive)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverFive)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column className='right'>
            <Segment className='imageTemplateSegment'>
              <Image
                src={`${PUBLIC_BUCKET_CDN}${BANNER_TEMPLATE.coverSix}`}
                alt='cover template 6'
                onClick={(e) => handleImageTemplateOnClick(e, BANNER_TEMPLATE.coverSix)}
                className={isCurrentSelected(BANNER_TEMPLATE.coverSix)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return <Fragment>{template}</Fragment>;
};


export default HHImageTemplates;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhImageTemplates.js